/**
 * Created by slava on 29/11/18
 */

cleverapps.Layout = cc.Node.extend({
    ctor: function (children, options) {
        this._super();

        this.options = options || {};

        this.setAnchorPoint(0.5, 0.5);

        if (children.length) {
            this.setItems(children);
        }
    },

    setItems: function (items, cleanup) {
        this.removeAllChildren(cleanup);

        items.forEach(function (item) {
            if (item) {
                this.addChild(item);
            }
        }, this);

        this.reshape();
    },

    reshape: function () {
        if (cleverapps.config.debugMode) {
            this.cleanupBorder();
        }

        this.children.forEach((child) => {
            child.setPosition(0, 0);
        });

        const children = this.options.onlyVisible
            ? this.children.filter((child) => child.visible)
            : this.children;

        cleverapps.UI.arrangeWithMargins(children, this.options);

        cleverapps.UI.wrap(this, {
            considerRotation: true,
            children
        });

        if (this.options.padding) {
            cleverapps.UI.wrapWithPadding(this, this.options.padding, true);
        }

        if (this.options.dimensions) {
            cleverapps.UI.setDimensions(this, this.options.dimensions);
        }

        // Per-child post-arrange nudge: a child may carry an optional layoutOffset (set declaratively by
        // the prefab "layout" primitive). Applied last - after wrap/padding/dimensions - so it shifts the
        // item within the already-sized content without moving the content anchor.
        this.children.forEach((child) => {
            if (child.layoutOffset) {
                child.setPosition(child.x + (child.layoutOffset.x || 0), child.y + (child.layoutOffset.y || 0));
            }
        });

        return this;
    },

    setOptions: function (options) {
        cleverapps.override(this.options, options);
        this.reshape();
    }
});

cleverapps.Layout.AsyncChild = cc.Node.extend({
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
    }
});

cleverapps.Layout.AsyncChild.prototype.reshape = function (content) {
    this.setContentSize2(content.width * content.scaleX, content.height * content.scaleY);
    this.addChild(content);
    content.setAlignment(this.width / 2, this.height / 2);

    if (this.parent) {
        this.doAlignment();

        if (this.parent.reshape) {
            this.parent.reshape();
        }
    }
};
